var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66723 1.33337L2.72953 8.45861C2.49699 8.73766 2.38072 8.87718 2.37894 8.99502C2.3774 9.09745 2.42305 9.19491 2.50273 9.2593C2.59439 9.33337 2.77601 9.33337 3.13925 9.33337H8.00056L7.33389 14.6667L13.2716 7.54147C13.5041 7.26243 13.6204 7.1229 13.6222 7.00507C13.6237 6.90263 13.5781 6.80517 13.4984 6.74078C13.4067 6.66671 13.2251 6.66671 12.8619 6.66671H8.00056L8.66723 1.33337Z",
    stroke: "#4C7D9F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapBlue);
export default __webpack_public_path__ + "static/media/zap-blue.8ea7e927d91d8a1b7e2a4857c843cab6.svg";
export { ForwardRef as ReactComponent };